var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCostToIncome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    stroke: "white",
    strokeWidth: 1,
    d: "M137.207 81.264c0-1.7-1.3-3-3-3h-61.6v-61.6c0-1.7-1.3-3-3-3-37.4 0-67.7 30.3-67.7 67.6s30.3 67.7 67.7 67.7c37.4 0 67.6-30.4 67.6-67.7zm-67.6 61.6c-34 0-61.6-27.7-61.6-61.6 0-33 26-60 58.6-61.6v61.5c0 1.7 1.3 3 3 3h61.5c-1.6 32.7-28.6 58.7-61.5 58.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    stroke: "white",
    strokeWidth: 1,
    d: "M86.564 1.671c-1.7 0-3 1.3-3 3v59.8c0 1.7 1.3 3 3 3h59.8c1.7 0 3-1.3 3-3 0-15.3-5.6-30.1-15.7-41.6-12-13.4-29.1-21.2-47.1-21.2zm3 59.8v-53.6c15.2.8 29.4 7.7 39.5 19.1 8.5 9.6 13.4 21.8 14.1 34.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostToIncome);
export default __webpack_public_path__ + "static/media/costToIncome.7b4ca7919193d6f9883ecdea46e1a56f.svg";
export { ForwardRef as ReactComponent };